import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormValidationService, StringValidator, SelectValidator,
  DateCompareValidator, RangeValidator } from '@westjetairlines/wjesd-validation-library';
import { ValidationMessages } from '@westjetairlines/wjesd-component-library';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ValidationMessages,
    StringValidator,
    SelectValidator,
    DateCompareValidator,
    RangeValidator
  ],
  providers: [
    FormValidationService
  ],
  exports: [ValidationMessages, StringValidator, SelectValidator, DateCompareValidator, RangeValidator]
})
export class ValidationModule { }



// WEBPACK FOOTER //
// ./src/app/shared/validation/validation.module.ts